/* eslint-disable no-unused-expressions */
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Dropdown, DropdownToggle,DropdownMenu  } from 'reactstrap';
import { format } from 'date-fns';
import flagIcon  from '../../../../Res/Icon/flagIcon.svg'
import './adminFlagsDropDown.css'

const AdminFlagsDropDown = ({ engineeringLock, isDemoBox, boxId }) => {
  const [dropDownToggle, setDropDownToggle] = useState(false)
  const  adminFlags   = useSelector(state => state.AppState.adminFlags);
  const  epikUpdates   = useSelector(state => state.AppState.boxDetails.box.epikUpdateStatus);
  const  epikLabBox   = useSelector(state => state.AppState.boxDetails.box.epikLabBox);
  const user = useSelector(state => state.AppState.user)
 
  const adminRoles = ['admin', 'quoteToolAdmin', 'superAdmin', 'companyGroupAdmin', 'enterpriseAdmin'];

  const getAdminFlagsMessages = (adminFlags) => {
    const messages = [];

    if (engineeringLock) {
      messages.push('Engineering Lock Set');
    }
    
    if (epikLabBox) {
      messages.push('Epik Lab Box');
    }

    if (isDemoBox) {
      messages.push('DemoBox is Set');
    }
    if (!epikUpdates) {
      messages.push('Epik Updates Disabled');
    }

    if (adminFlags?.vtmScheduled?.isChecked && adminFlags?.vtmScheduled?.date && adminRoles?.includes(user?.role)) {
      messages.push(`VTM Scheduled  ${format(new Date(adminFlags?.vtmScheduled?.date), 'MM/dd/yyyy') || ''}`);
    }

    if (adminFlags?.highVisibility) {
      messages.push('High Visibility');
    }
    if (adminFlags?.customDialPlan) {
      messages.push('Custom Dial Plan');
    }
    if (adminFlags?.customConfiguration) {
      messages.push('Custom Configuration');
    }
    if (adminFlags?.customerInstall) {
      messages.push('Customer Install');
    }
    if (adminFlags?.escalateToEngineering) {
      messages.push('Escalate to Engineering');
    }
    if (adminFlags?.poc) {
      messages.push('POC');
    }
    if (adminFlags?.fireWatch) {
      messages.push('Fire Watch');
    }
    if (adminFlags?.openRepairTicket?.isChecked && adminFlags?.openRepairTicket?.ticketNumber && 
      adminRoles?.includes(user?.role)) {
        messages.push(`Open Repair Ticket ${adminFlags?.openRepairTicket?.ticketNumber}`);
    }
    if (adminFlags?.alarmMonitoringCompanyCutover) {
      messages.push('Alarm Monitoring Company');
    }
    if (adminFlags?.deliveredDialToneCutover) {
      messages.push('Delivered Dial tone - Cutover TBD');
    }
    if (adminFlags?.lteOnlyLan) {
      messages.push('LTE Only - LAN TBD');
    }
    if (adminFlags?.lteOnly) {
      messages.push('LTE Only');
    }
    if (adminFlags?.callRecordingEnabled) {
      messages.push('Call Recording Enabled');
    }

    return messages;
  }
  const messages = getAdminFlagsMessages(adminFlags);

  const hasLongMessages =
    messages.includes('Alarm Monitoring Company') || messages.includes('Delivered Dial Tone - Cutover TBD');
  return (
    <>
      {adminFlags?.nidBox && (
        <div
          className="nid-enabled-label"
          style={{ width: hasLongMessages ? '230px' : '190px' }}
        >
          NID Enabled
        </div>
      )}
      {(engineeringLock || isDemoBox || !epikUpdates || messages.length > 0) ?  
      <div className='admin-flags-dropdown-container'>
        <img src={flagIcon} className='flag-icon' />
        <Dropdown isOpen={dropDownToggle} toggle={() => setDropDownToggle(!dropDownToggle)}
          direction={'end'}
          >
            <DropdownToggle caret className='dropdown-toggle-container' style={{ width: hasLongMessages ? '230px' : '190px' }}>View Admin Flags</DropdownToggle>
            <DropdownMenu className='dropdown-menu-container'>
              <div style={{ padding: 0 }}>
                {messages.length > 0
                  ? messages.map((message, index) => (
                    <div key={index} className="admin-flag-item">{message}</div>
                  ))
                  : <div className="admin-flag-item">No admin flags set</div>}
              </div>
            </DropdownMenu>
        </Dropdown>            
    </div> : null}
    </>
  );
};
export default AdminFlagsDropDown;
